var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"-badge",style:(`background-color: ${_vm.backgroundColor};`)},[_c('span',{staticClass:"-badge__bullet",style:(`background-color: ${_vm.mainColor};`)}),_c('span',{staticClass:"-badge__text",style:(`color: ${_vm.mainColor};`)},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }